// pages/support_mobile.js
import React from 'react';
import BottomNavMobile from '../Components/BottomNavMobile';
import './support_mobile.css';

export default function SupportMobile({
    role,
    tickets,
    activeTicketId,
    setActiveTicketId,
    activeTicketDetails,
    messages,
    inputText,
    setInputText,
    handleSendMessage,
    handleResolveTicket,
    messagesEndRef
}) {
    return (
        <div className="mobile-support-container" dir="rtl">
            {/* الرأس واختيار التذكرة */}
            <div className="mobile-support-header">
                <h2 className="ministry-title-primary">الجمهورية العربية السورية</h2>
                <h3 className="ministry-title-secondary">وزارة الصحة</h3>
                
                {tickets.length > 0 && (
                    <select
                        className="mobile-ticket-select"
                        value={activeTicketId || ""}
                        onChange={(e) => setActiveTicketId(e.target.value)}
                    >
                        {tickets.map(t => (
                            <option key={t.id} value={t.id}>
                                {t.subject} - {new Date(t.created_at).toLocaleDateString()} {t.status === 'resolved' ? '(محلولة)' : ''}
                            </option>
                        ))}
                    </select>
                )}
            </div>

            {/* منطقة الرسائل والمحادثة */}
            <div className="mobile-messages-area">
                {messages.length === 0 ? (
                    <div className="mobile-no-messages"></div>
                ) : (
                    messages.map((msg) => (
                        <div 
                            key={msg.id} 
                            className={`mobile-msg-wrapper ${msg.sender === 'user' ? 'mobile-msg-user' : 'mobile-msg-support'}`}
                        >
                            <div className={`mobile-msg-bubble ${msg.sender === 'user' ? 'mobile-bubble-user' : 'mobile-bubble-support'}`}>
                                {msg.text}
                            </div>
                            <span className={`mobile-msg-footer ${msg.sender === 'user' ? 'mobile-footer-user' : 'mobile-footer-support'}`}>
                                {msg.footer}
                            </span>
                        </div>
                    ))
                )}
                <div ref={messagesEndRef} />
            </div>

            {/* منطقة إدخال الرسالة - محدثة لتطابق الحاسوب */}
            <div className="mobile-input-area">
                <form onSubmit={handleSendMessage} className="mobile-input-form">
                    
                    {/* استخدام label يغطي المساحة الزرقاء بالكامل هو الحل النهائي */}
                    <label htmlFor="mobileChatInput" className="mobile-chat-input-label">
                        <input
                            id="mobileChatInput"
                            type="text"
                            value={inputText}
                            onChange={(e) => setInputText(e.target.value)}
                            placeholder="اكتب رسالتك هنا..."
                            className="mobile-chat-input"
                            disabled={activeTicketDetails && (activeTicketDetails.status === 'resolved' || activeTicketDetails.status === 'closed')}
                        />
                    </label>
                    
                    <button
                        type="submit"
                        className="mobile-send-btn"
                        disabled={activeTicketDetails && (activeTicketDetails.status === 'resolved' || activeTicketDetails.status === 'closed')}
                    >
                        {/* أيقونة الإرسال SVG المطابقة للحاسوب */}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'scaleX(-1)' }}>
                            <line x1="22" y1="2" x2="11" y2="13"></line>
                            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                        </svg>
                    </button>
                </form>
                {activeTicketDetails && (activeTicketDetails.status === 'resolved' || activeTicketDetails.status === 'closed') && (
                    <p className="mobile-resolved-text">هذه التذكرة مغلقة ولا يمكن الرد عليها.</p>
                )}
            </div>

            {/* شريط التنقل السفلي الخاص بالموبايل */}
            <BottomNavMobile />
        </div>
    );
}